import React from 'react';
import Contact from '../components/Contact';
import { useScrollReveal } from '../hooks/useScrollReveal';

function ContactPage() {
  useScrollReveal();
  return (
    <main className="page">
      <Contact />
    </main>
  );
}

export default ContactPage;
